export const footerBG = {
  "contactHours": "Работно време",
  "week": "Понеделник – Петък",
  "contactUs": "Свържете се с нас",
  "address": "ул. Мезогион 131, Маруси 15126",
  "findUs": "Намерете ни на картата",
  "contact": "Контакти",
  "privacyPolicy": "Политика за поверителност",
  "termsOfService": "Общи условия",
  "stayConnected": "Връзка с нас",
  "cookiesTitle": "Използване на бисквитки",
  "aboutUs": "За нас",
  "cookiesText": "Използваме само необходимите бисквитки. Вашите лични данни не се съхраняват в тях.",
  "cookiesAccept": "Приемам",
  "cookiesManagement": "Управление на бисквитките",
  "cookiesManage": "Управление",
  "accessibilityTitle": "Достъпност",
  "fontIncrease": "Увеличаване на шрифта",
  "fontDecrease": "Намаляване на шрифта",
  "greyscale": "Сива скала",
  "highContrast": "Висок контраст",
  "negativeContrast": "Негативен контраст",
  "lightBackground": "Светъл фон",
  "linksUnderline": "Подчертаване на връзките",
  "readableFont": "Четлив шрифт",
  "reset": "Нулиране",
  "paymentOptions": "Начини на плащане",
  "deliveryOptions": "Начини на доставка",
  "openingTime": "Работно време",
  "loginRegister": "Вход/Регистрация",
  "messagingTitle": "Поддръжка",
  "messagingSubTitle": "Изпратете съобщение с вашите въпроси!",
  "message": "Съобщение",
  "installBringFood": "Започнете с BringFood!",
  "usefull": "Полезно",
  "company": "Компания",
  "faq": "Често задавани въпроси",
  "chatPlaceholder": "Въведете текст...",
  "restaurantClosed": "Заведението е затворено в момента и не можем да приготвим вашата поръчка",
  "holidayText": "Заведението ще остане затворено днес",
  "allDay": "Цял ден",
  "to": "До"
}